<template>
<div class="internal-bady" :dir="isHebrew ? 'rtl' : 'ltr'">
<WhatsappChet/>
<NavBar/>
<!-- <div id="header"></div> -->
<div id="top"></div>
<div class="px-3 px-md-4 home-ride-manager-wrap" id="ride-manager-hero">
  <div
    class="ride-manager-hero-panel rounded-5"
    :style="rideManagerHeroBgStyle"
  >
    <div class="ride-manager-hero-layers" aria-hidden="true"></div>
    <div class="ride-manager-hero-edge-glow" aria-hidden="true"></div>
    <div class="container py-4 py-md-5 position-relative ride-manager-hero-content">
      <div class="row ride-manager-hero-row">
        <div class="col-12 text-center ride-manager-hero-head">
          <p class="ride-manager-kicker mb-2 mb-lg-3">{{ t('homeRideManagerKicker') }}</p>
          <h2 class="text-white fw-bold mb-3 ride-manager-title">
            {{ t('homeRideManagerHeroTitle') }}
          </h2>
          <p class="text-white ride-manager-subtitle ride-manager-subtitle--head mb-0">
            {{ t('homeRideManagerHeroSubtitle') }}
          </p>
        </div>
      </div>
      <div class="row align-items-stretch g-4 g-lg-5 mt-4 mt-lg-5 ride-manager-hero-actions-row">
        <div class="col-lg-6 d-flex flex-column justify-content-center ride-manager-actions-col">
          <div class="ride-manager-cta-wrap">
            <router-link
              to="/welcome-ride-managers"
              class="btn ride-manager-cta btn-lg rounded-pill px-4 px-md-5 py-3 fw-semibold text-white mb-3 d-inline-flex align-items-center justify-content-center"
            >
              <span class="ride-manager-cta-shine" aria-hidden="true"></span>
              <span class="ride-manager-cta-label">{{ t('homeRideManagerHeroCta') }}</span>
              <i :class="['fa-solid', 'ride-manager-cta-icon', 'ms-2', isHebrew ? 'fa-chevron-left' : 'fa-chevron-right']" aria-hidden="true"></i>
            </router-link>
          </div>
          <div class="mt-2 mt-md-3">
            <router-link
              to="/single_ride_with_map/6095"
              class="ride-manager-example-link d-inline-flex align-items-center"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{{ t('homeRideManagerExampleLink') }}</span>
            </router-link>
          </div>
        </div>
        <div class="col-lg-6 d-flex flex-column justify-content-center ride-manager-bullets-col mt-4 mt-lg-0">
          <div class="ride-manager-bullets-card rounded-4">
            <ul class="list-unstyled mb-0 text-white ride-manager-list">
              <li class="d-flex align-items-start ride-manager-li">
                <span class="ride-manager-check flex-shrink-0" aria-hidden="true"><i class="fa-solid fa-check"></i></span>
                <span>{{ t('homeRideManagerBullet1') }}</span>
              </li>
              <li class="d-flex align-items-start ride-manager-li">
                <span class="ride-manager-check flex-shrink-0" aria-hidden="true"><i class="fa-solid fa-check"></i></span>
                <span>{{ t('homeRideManagerBullet2') }}</span>
              </li>
              <li class="d-flex align-items-start ride-manager-li mb-0">
                <span class="ride-manager-check flex-shrink-0" aria-hidden="true"><i class="fa-solid fa-check"></i></span>
                <span>{{ t('homeRideManagerBullet3') }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="px-3 px-md-4" id="welcome-section">
    <div 
        :style="mainHomeImageStyle"
        :class="['container-fluid', 'bg-welcome', 'rounded-5', 'd-flex', 'align-items-center', isEnglish ? 'bg-welcome-mirrored' : '']">
        <div class="container">
            <div class="row  position-index">
                <div class="col col-lg-8 col-xl-6 d-flex flex-column gap-3 gap-md-5">
                    <h1 class="text-center text-welcome text-white mb-0">
                        {{ t('homeHeroTitle') }}
                    </h1>                    
                    <div class="input-group mb-0 mb-md-3">
                        <div class="input-icon w-100">
                            <i class="fa-solid fa-plane12 fs-3 pe-2">
                              <img
                                src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fplane_search_trip.png?alt=media&token=abba34a2-a85a-4044-88f0-96eb579cd0bb"
                                height="31px"
                                alt=""
                                class="clickable fa-solid image-31px fa-plane_image fs-3 pe-2"
                                @click="goToSearchRideByName">  
                            </i>
                            <gmap-autocomplete
                                @place_changed="onPlaceSelected"
                                :select-first-on-enter="true"
                                v-on:input="handleInput"
                                class="form-control pading_top_and_butom_3 text-end py-3 fs-5 rounded-pill border-0 bg-white shadow "
                                :placeholder="t('homeSearchPlaceholder')"
                                :options="{
                                fields: ['geometry'],
                                sessionToken: sessionToken,
                              }"
                            >
                            </gmap-autocomplete>
                        </div>
                    </div>
                    <div>
                        <p class="text-end fs-4 fw-semibold text-white mb-1 mb-md-2 text-align-center">
                            {{ t('homeWatchVacationsIntro') }}
                        </p>
                        <div class="justify-content-space-around d-flex gap-2 gap-md-3">
                            <button 
                                class="btn btn-warning px-3 px-md-4 py-3 rounded-pill border border-2 border-white fw-semibold fs-5"
                                @click="goToSerchattractionPage()"
                            >
                                {{ t('homeWatchVacations') }}
                            </button>
                            <button 
                                class="btn btn-primary px-3 px-md-4 py-3 rounded-pill border border-2 border-white fw-semibold fs-5"
                                @click="internalOpenRideInformationPage()"
                            >
                                {{ t('homeShareVacation') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="py-4 py-md-5" id="adventures-trip">
    <div class="container">
        <h2 class="text-center fw-bold">{{ t('homeStartWithVacation') }}</h2>
        <TripsImagePresentation/>
        <div class="d-flex justify-content-center">
            <button 
                class="btn btn-warning px-5 py-3 rounded-pill fw-semibold fs-5"
                @click="goToSerchattractionPage()"
            >
                {{ t('homeWatchVacationsDb') }}
            </button>
        </div>
    </div>
</div>
<HowItWorksNew/>

<div class="container-fluid py-5 position-relative overflow-hidden" id="what-can-do">
    <div>
        <img alt="" class="background-image background-image-max-with-none" src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fcircles-background.png?alt=media&token=d420088e-66c6-4c95-bd3b-2f218dd36aba">
    </div>
    <div class="container py-5">
        <div class="d-flex justify-content-center">
            <div class="w-75 full-width">
                <h2 class="text-center fw-bold black margin-for-h2">
                    {{ t('homeWhatCanDoTitle') }}<span class="text-primary">Trip</span><span class="text-secondary">planner</span>
                </h2>
                <p class="text-muted text-center fs-6 what_can_be_done_explanation">
                    {{ t('homeWhatCanDoIntro') }}
                </p>
            </div>
        </div>
        <div class="row justify-content-center align-items-stretch">
            <div class="col-sm-6 col col-lg-4 mb-2 mb-md-0 d-flex">
                <div class="card border-0 rounded-5 shadow-sm p-md-2 w-100 d-flex flex-column">
                    <div class="card-body d-flex flex-column gap-md-3 gap-2 text-center flex-grow-1">
                        <div class="rounded-2 bg-card"
                             style="height: 200px; background-image: url('https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fview-trip.jpg?alt=media&token=a957844f-8a7b-4d0d-b828-809f46a9a702')"></div>
                        <div class="flex-grow-1 d-flex flex-column justify-content-between">
                            <h4 class="fw-bold mb-0 black">
                                {{ t('homePlanningVacation') }}
                            </h4>
                            <p class="fs-6 mb-0 text-muted what_can_be_done_explanation">
                                {{ t('homePlanningVacationDesc') }}
                            </p>
                        </div>
                        <button 
                            class="gap-10 w-100 btn btn-warning px-5 py-3 rounded-pill fw-semibold fs-5 d-flex align-items-center justify-content-center mt-auto"
                            @click="goToSerchattractionPage()"
                        >
                            {{ t('homeWatchVacations') }}
                            <i class="ms-2 fa-solid fa-face-smile-beam fs-4"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col col-lg-4 mb-2 mb-md-0 d-flex">
                <div class="card border-0 rounded-5 shadow-sm p-md-2 w-100 d-flex flex-column">
                    <div class="card-body d-flex flex-column gap-md-3 gap-2 text-center flex-grow-1">
                        <div class="rounded-2 bg-card"
                             style="height: 200px; background-image: url('https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fshare-trip.jpg?alt=media&token=20e32b74-5566-49af-ac8a-2eb62829f20f')"></div>
                        <div class="flex-grow-1 d-flex flex-column justify-content-between">
                            <h4 class="fw-bold mb-0 black">
                                {{ t('homeBackFromVacation') }}
                            </h4>
                            <p class="fs-6 mb-0 text-muted what_can_be_done_explanation">
                                {{ t('homeBackFromVacationDesc') }}
                            </p>
                        </div>
                        <button 
                            class="gap-10 w-100 btn btn-primary px-5 py-3 rounded-pill fw-semibold fs-5 d-flex align-items-center justify-content-center mt-auto"
                            @click="internalOpenRideInformationPage()"
                        >
                            {{ t('homeUploadVacation') }}
                            <i class="ms-2 fa-solid fa-share-nodes fs-4"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container py-3 py-md-5">
        <div class=" d-flex justify-content-center">
            <div class="w-75 full-width">
                <h2 class="text-center fw-bold">{{ t('homeRecommendedTrips') }}</h2>
                <p class="text-muted text-center fs-6 what_can_be_done_explanation">
                  {{ t('homeRecommendedTripsIntro') }}
                </p>
            </div>
        </div>
        <div class="row my-3 my-md-5">
          <RecommendedTrips/>
        </div>
        <!-- <div class="row my-3 my-md-5" id="recommended-trips"></div> -->
        <div class="d-flex justify-content-center pb-5">
            <button 
                class="btn btn-primary px-5 py-3 rounded-pill fw-semibold fs-5 z-2"
                @click="goToSerchattractionPage()"
            >
              {{ t('homeWatchSuccessfulVacations') }}
            </button>
        </div>
    </div>
</div>

<div id="shared-trips">
    <div class="container-fluid py-5 bg-light-blue">
<!--         <h2 class="text-center fw-bold">Recently shared trips</h2>
        <div class="carousel slide carousel-height" data-bs-ride="carousel"
             id="carouselExampleAutoplaying">
            <div class="carousel-inner container-md p-0 d-flex h-100">
                <div class="carousel-item active p-2 py-md-4 px-md-3 my-auto">
                    <div class="card shadow-sm border-0 rounded-5 p-1 p-md-3">
                        <div class="card-body d-flex align-items-center">
                            <div class="row">
                                <div class="col-md-5 mb-md-0 mb-3">
                                    <div class="bg-card rounded-2 review-image"
                                         style="background-image: url('assets/images/homepage/starter-trips/trip2.png')"></div>
                                </div>
                                <div class="col-md-7 d-flex flex-column gap-2 gap-md-3">
                                    <h4 class="text-end fs-4">Flachau - two weeks in Austria</h4>
                                    <div class="d-flex justify-content-end gap-2">
                                        <div class="bg-light-blue d-inline-flex px-3 py-2 rounded-pill align-items-center justify-content-center fs-6">
                                            <i class="fa-solid fa-calendar-days text-primary fs-5 me-2"></i> 2 Weeks
                                        </div>
                                        <div class="bg-light-orange d-inline-flex px-3 py-2 rounded-pill align-items-center justify-content-center fs-6">
                                            <i class="fa-solid fa-map-pin text-orange fs-5 me-2"></i> Austria
                                        </div>
                                    </div>
                                    <div>
                                        <p class="text-muted text-end fs-6">
                                            After countless searches, readings and research, we managed to put together
                                            the
                                            trip
                                            that would be perfect for our family in Austria. We decided on a trip area
                                            (Salzburg
                                            region) and a place to stay from where we went on a star trip. The weather
                                            was
                                            changeable. In Vienna it is hot during the day, cooler during the night, in
                                            the
                                            Salzburg
                                            region and on the trips where we went to the mountains it was cold and
                                            sometimes
                                            rainy.
                                            <br><br>
                                            <i>Partnered by Avshalom Katz</i>
                                            <br>
                                            01.09.2019-20.08.2019
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="carousel-item py-md-4 px-md-3 my-auto">
                    <div class="card shadow-sm border-0 rounded-5 p-2 p-md-3">
                        <div class="card-body d-flex align-items-center">
                            <div class="row">
                                <div class="col-md-5 mb-3">
                                    <div class="bg-card rounded-2 review-image"
                                         style="background-image: url('assets/images/homepage/starter-trips/trip3.png')"></div>
                                </div>
                                <div class="col-md-7 d-flex flex-column gap-2 gap-md-3">
                                    <h4 class="text-end fs-4">Two weeks in Austria - Salzburg and Tyrol area
                                    </h4>
                                    <div class="d-flex justify-content-end gap-2">
                                        <div class="bg-light-blue d-inline-flex px-3 py-2 rounded-pill align-items-center justify-content-center fs-6">
                                            <i class="fa-solid fa-calendar-days text-primary fs-5 me-2"></i> 2 Weeks
                                        </div>
                                        <div class="bg-light-orange d-inline-flex px-3 py-2 rounded-pill align-items-center justify-content-center fs-6">
                                            <i class="fa-solid fa-map-pin text-orange fs-5 me-2"></i> Austria
                                        </div>
                                    </div>
                                    <div>
                                        <p class="text-muted text-end fs-6">
                                            Hi, I'm Ashkar (Erblich-Brifman) and I'm a children's and youth author and
                                            host of online writing workshops for children. In addition, I am married and
                                            the mother of three daughters. Our family is an avid traveler. I chose to
                                            share with you and share with you our trip to Austria.
                                            <br><br>
                                            <i>Partnered by Ascher Erblich-Brifman</i>
                                            <br>
                                            26.07.2021-12.07.2021
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="carousel-control-prev" data-bs-slide="prev"
                    data-bs-target="#carouselExampleAutoplaying"
                    type="button">
                <span aria-hidden="true" class="carousel-control-prev-icon"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" data-bs-slide="next" data-bs-target="#carouselExampleAutoplaying"
                    type="button">
                <span aria-hidden="true" class="carousel-control-next-icon"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div> -->
    </div>
</div>

<div class="container-fluid position-relative overflow-hidden" id="why-choose-tripplanner">
    <div>
        <img 
            alt=""
            class="background-image"
            src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fcircles-background.png?alt=media&token=d420088e-66c6-4c95-bd3b-2f218dd36aba">
    </div>
    <div class="container py-5">
        <h2 class="text-center fw-bold py-5">{{ t('homeWhyTripplanner') }}<span class="text-primary">Trip</span><span
                class="text-secondary">planner</span>?
        </h2>
        <div class="row align-items-stretch py-4">
            <div class="col-md-6 mb-3">
                <div class="card border-0 rounded-5 shadow-sm p-md-2 h-100">
                    <div class="card-body d-flex flex-column gap-md-3 gap-2 text-center">
                        <img alt="" class="image-how-it-works"
                             src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fsearch-trips.svg?alt=media&token=000e4a8d-2550-484d-b580-b9dda1f4eebd">
                        <h4 class="fw-bold mb-0">
                            {{ t('homeWhyCard1Title') }}
                        </h4>
                        <p class="fs-6 mb-0 text-muted what_can_be_done_explanation">
                            {{ t('homeWhyCard1Desc') }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="card border-0 rounded-5 shadow-sm p-md-2 h-100">
                    <div class="card-body d-flex flex-column gap-md-3 gap-2 text-center">
                        <img alt="" class="image-how-it-works"
                             src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Flarge-database.svg?alt=media&token=3560c0aa-ba18-4e39-906d-257ffc736401">
                        <h4 class="fw-bold mb-0">
                            {{ t('homeWhyCard2Title') }}
                        </h4>
                        <p class="fs-6 mb-0 text-muted what_can_be_done_explanation">
                          {{ t('homeWhyCard2Desc') }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="card border-0 rounded-5 shadow-sm p-md-2 h-100">
                    <div class="card-body d-flex flex-column gap-md-3 gap-2 text-center">
                        <img alt="" class="image-how-it-works"
                             src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fbooking-of-hotels.svg?alt=media&token=e9025e97-32ea-44ad-ade7-b958af1fff86">
                        <h4 class="fw-bold mb-0">
                            {{ t('homeWhyCard3Title') }}
                        </h4>
                        <p class="fs-6 mb-0 text-muted what_can_be_done_explanation">
                            {{ t('homeWhyCard3Desc') }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <div class="card border-0 rounded-5 shadow-sm p-md-2 h-100">
                    <div class="card-body d-flex flex-column gap-md-3 gap-2 text-center">
                        <img alt="" class="image-how-it-works"
                             src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Feasy-editing.svg?alt=media&token=37c37af9-9590-45d2-b86e-df4c36d5b15b">
                        <h4 class="fw-bold mb-0">
                            {{ t('homeWhyCard4Title') }}
                        </h4>
                        <p class="fs-6 mb-0 text-muted what_can_be_done_explanation">
                            {{ t('homeWhyCard4Desc') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center pb-5">
            <button 
                class="btn btn-primary px-5 py-3 rounded-pill fw-semibold fs-5 z-2"
                @click="goToSerchattractionPage()"
            >
                {{ t('homeWatchSuccessfulVacations') }}
            </button>
        </div>
    </div>
</div>
<!-- <div class="container-fluid bg-light-blue py-md-5">
    <div class="container my-md-5 my-3 py-3" id="collaborators">
      <CollaboratorsWith/>
    </div>
</div> -->

<!-- <div id="footer"> -->
  <PageFooterNew/>
<!-- </div> -->
</div>
</template>


<script src="/src/plugins/component-import.js"></script>
<script src="/src/plugins/load-starter-trips.js"></script>
<script src="/src/plugins/load-recommended-trips.js"></script>


<script>
import HowItWorksNew from "@/components/HowItWorksNew"
import NavBar from "@/components/NavBar.vue"
import TripsImagePresentation from "@/components/TripsImagePresentation.vue"
import RecommendedTrips from "@/components/RecommendedTrips.vue"
import CollaboratorsWith from "@/components/CollaboratorsWith.vue"
import PageFooterNew from "@/components/PageFooterNew.vue"
import WhatsappChet from "@/components/WhatsappChet";
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: "NewHomePage",
  mixins: [translationMixin],
  components: {
    HowItWorksNew,
    NavBar,
    TripsImagePresentation,
    RecommendedTrips,
    CollaboratorsWith,
    PageFooterNew,
    WhatsappChet,
    
  },
  data() {
    return {
      sessionToken: null,
      mainHomeImageStyle: {
          '--home-bg-image': `url('https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fwelcome-trip.jpg?alt=media&token=0454fe77-65ec-4ece-8c99-6d978d2a7bbd')`,
      },
      rideManagerHeroBgStyle: {
        '--rm-bg': `url('https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/gui_images%2Ftravel-lake-forest-mountains-from-water.jpeg?alt=media&token=36ed69bc-4e96-46e3-b0aa-97f1ef21cbb6')`,
      },
      userSearchInput: "",
      gMapPlace: "",
      jumbotronHeight: "",
      alignLocation: "end",
      value1: 2,
      value2: 2,
      value3: 0,
    };
  },
  computed: {
    ...mapGetters(["isAppLoggedIn", "isMobile"]),
    latestRides() {
      return [
        {
          imagePath: 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/1_30_Mar_2021_16%3A34%3A03_GMT?alt=media&token=983aa4d1-62ae-4436-8518-08f9e2558d0a',
          header: this.t('locationCardFlachauTwoWeeks'),
          openText: this.t('homePageOpenTextAustria'),
          route: '/single_ride_with_map/1',
          sharedBy: this.t('homePageSharedByAvshalom'),
          dates: '01.09.2019-20.08.2019',
        },
        {
          imagePath: 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/ride72_homepage%20(1).jpg?alt=media&token=9cb847dd-3f58-44ae-b41e-438b2db42cda',
          header: this.t('locationCardSalzburgTirolTwoWeeks'),
          openText: this.t('homePageOpenTextSalzburgTirol'),
          route: '/single_ride_with_map/72',
          sharedBy: this.t('homePageSharedByAshchar'),
          dates: '26.07.2021-12.07.2021',
        },
        {
          imagePath: 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/attractions%2F183_27_Aug_2022_17%3A17%3A40_GMT?alt=media&token=ed9f07cf-e111-4805-92c6-e0456e2ef8ff',
          header: this.t('homePagePolandSlovakiaTrip'),
          openText: this.t('homePageOpenTextPolandSlovakia'),
          route: '/single_ride_with_map/183',
          sharedBy: this.t('homePageSharedByAvshalomWithSpace'),
          dates: '25.08.2022-11.08.2022',
        },
      ];
    },
    selectsOptions() {
      return {
        first: {
          label: { text: this.t('homePageDays') },
          options: ["1", "2", "3", "4", "5", "6", "7", "14", "21"]
        },
        second: {
          label: { text: this.t('homePagePeopleReversed') },
          options: ["choice 1", "choice 2", "choice 3"]
        },
        third: {
          label: { text: this.t('homePageEnterLocationReversed') },
          options: ["choice 1", "choice 2", "choice 3"]
        }
      };
    },
    selects() {
      return [
        [{ text: this.t('homePageDaysReversed'), value: null }, "choice 1", "choice 2", "choice 3"],
        [{ text: this.t('homePagePeopleReversed'), value: null }, "choice 1", "choice 2", "choice 3"],
        [{ text: this.t('homePageEnterLocationReversed'), value: null }, "choice 1", "choice 2", "choice 3"]
      ];
    }
  },
  mounted() {
    this.$gmapApiPromiseLazy().then(() => {
      this.sessionToken = new google.maps.places.AutocompleteSessionToken();
    });
  },
  methods: {
    ...mapActions(["openRideInformationPage",
                   "searchRidesByGeoPoint",
                   "goToSerchattractionPage",
                   "showModalWithParameters",
                   "fetchGlobalRidesByName",
                   ]),
    onPlaceSelected(place) {
      this.searchRidesByGeoPoint(place);
      this.sessionToken = new google.maps.places.AutocompleteSessionToken();
    },
    handleInput(event) {
      this.userSearchInput = event.target.value
    },
    goToSearchRideByName(){
      if(this.userSearchInput == ""){
        this.goToSerchattractionPage();
        return
      }
      const link = '/search_ride_by_name/' + this.userSearchInput
      this.$router.push(link)
    },
    internalOpenRideInformationPage(){
      this.$router.push('/insert_new_ride_from_google_photos')
    },
    getImageHeight(imageLoadedCb) {
      let image = new Image();
      image.onload = () => {
        imageLoadedCb(image.height);
      };
      image.src = "https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/gui_images%2Fheader.png?alt=media&token=350c3bd1-ef0e-4d52-99cf-465796ffae0b"
    },
    getHeight(height) {
      this.jumbotronHeight = height + "px";
    },

  },
  mounted() {
    this.getImageHeight(this.getHeight);
    if( window.innerWidth > 768 ){
      this.alignLocation = 'end';
    }
    else{
      this.alignLocation = 'center';
    }
  },
  metaInfo() {
    return {
      title: this.t('homePageNewMetaTitle'),
      meta: [
        { property: 'og:title', content: this.t('homePageNewMetaTitle') },
        { property: 'og:description', content: this.t('homeOgDescription') },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://tripplanner.co.il' },
        { property: 'og:image', content: 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fphone_display_app.png?alt=media&token=ccfc9989-224e-40be-ae57-aa6ed4db8637' },
        { name: 'description', content: this.t('homeMetaDescription') }
      ],
      link: [
        { rel: 'canonical', href: 'https://tripplanner.co.il' }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'TripPlanner',
            url: 'https://tripplanner.co.il',
            logo: 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Ffavicon_colored_tp.png?alt=media&token=8772f6c2-3657-465e-a33b-6b192904a3f5'
          }
        }
      ]
    };
  },
  created() {
    if (this.isMobile){
      var resizedUrl = 'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fhome_page_image_mobile_1.jpg?alt=media&token=72aaafda-25e5-471f-9bc2-44508cf0c568';
      this.mainHomeImageStyle = { '--home-bg-image': `url('${resizedUrl}')` };
    }
  },
};
</script>

<style scoped>




.home-ride-manager-wrap {
  padding-top: 98px;
  padding-bottom: 1rem;
}

.ride-manager-hero-panel {
  position: relative;
  overflow: hidden;
  isolation: isolate;
  /* Neutral dark scrim so the photo stays natural; only a hint of cool tone */
  background-image:
    linear-gradient(
      135deg,
      rgba(18, 22, 28, 0.72) 0%,
      rgba(28, 32, 38, 0.58) 48%,
      rgba(12, 14, 18, 0.75) 100%
    ),
    var(--rm-bg);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 280px;
  box-shadow:
    0 28px 56px -12px rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.1) inset;
}

.ride-manager-hero-layers {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background:
    radial-gradient(ellipse 100% 70% at 50% -25%, rgba(255, 255, 255, 0.14), transparent 55%),
    radial-gradient(ellipse 60% 50% at 100% 50%, rgba(120, 200, 185, 0.08), transparent 50%),
    linear-gradient(180deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.38) 100%);
  pointer-events: none;
  z-index: 0;
}

.ride-manager-hero-edge-glow {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.22);
  pointer-events: none;
  z-index: 1;
}

.ride-manager-hero-content {
  z-index: 2;
}

.ride-manager-hero-row {
  animation: ride-manager-enter 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.ride-manager-hero-actions-row {
  animation: ride-manager-enter 0.65s cubic-bezier(0.22, 1, 0.36, 1) 0.08s both;
}

@keyframes ride-manager-enter {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ride-manager-kicker {
  font-size: clamp(0.95rem, 1.2vw, 1.18rem);
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(180, 230, 255, 0.95);
  text-shadow: 0 1px 12px rgba(0, 0, 0, 0.2);
}

.ride-manager-hero-head {
  padding-top: 0.25rem;
}

.ride-manager-hero-head .ride-manager-kicker {
  text-align: center;
}

.ride-manager-title {
  font-size: clamp(2.65rem, 3.15vw, 3.85rem);
  line-height: 1.12;
  letter-spacing: -0.035em;
  font-weight: 800;
  color: #fff;
  text-shadow:
    0 2px 24px rgba(0, 0, 0, 0.28),
    0 0 60px rgba(255, 255, 255, 0.06);
}

.ride-manager-hero-head .ride-manager-title {
  max-width: 58rem;
  margin-left: auto;
  margin-right: auto;
}

.ride-manager-subtitle {
  font-size: clamp(1.3rem, 2.05vw, 1.7rem);
  line-height: 1.55;
  opacity: 0.94;
}

.ride-manager-subtitle--head {
  max-width: 48rem;
  margin-left: auto;
  margin-right: auto;
  padding-top: 0.35rem;
}

.ride-manager-actions-col {
  align-items: center;
  text-align: center;
}

@media (min-width: 992px) {
  [dir="ltr"] .ride-manager-actions-col {
    align-items: flex-start;
    text-align: left;
  }
  [dir="rtl"] .ride-manager-actions-col {
    align-items: flex-end;
    text-align: right;
  }
}

.ride-manager-cta-wrap {
  perspective: 800px;
}

.ride-manager-cta {
  position: relative;
  overflow: hidden;
  border: none;
  font-size: clamp(1.18rem, 1.55vw, 1.38rem);
  background: linear-gradient(135deg, #42dcc0 0%, #34d0b6 35%, #0a9ec4 100%);
  box-shadow:
    0 10px 28px rgba(52, 208, 182, 0.42),
    0 0 0 1px rgba(255, 255, 255, 0.25) inset;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease;
}

.ride-manager-cta-shine {
  position: absolute;
  top: 0;
  left: -40%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.35),
    transparent
  );
  transform: skewX(-18deg);
  animation: ride-manager-shine 4.5s ease-in-out infinite;
  pointer-events: none;
}

@keyframes ride-manager-shine {
  0%,
  100% {
    left: -50%;
    opacity: 0;
  }
  15% {
    opacity: 0.5;
  }
  35% {
    left: 120%;
    opacity: 0;
  }
}

.ride-manager-cta-label {
  position: relative;
  z-index: 1;
}

.ride-manager-cta-icon {
  position: relative;
  z-index: 1;
  font-size: 0.9em;
  opacity: 0.95;
}

.ride-manager-cta:hover {
  color: #fff;
  transform: translateY(-3px) scale(1.01);
  box-shadow:
    0 16px 40px rgba(52, 208, 182, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.35) inset;
  text-decoration: none;
}

.ride-manager-cta:active {
  transform: translateY(-1px) scale(1);
}

.ride-manager-example-link {
  padding: 0.6rem 1.2rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.22);
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  font-size: clamp(1.12rem, 1.5vw, 1.3rem);
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.ride-manager-example-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  text-decoration: none;
}

/* Mobile: center card; lg+: no stretch + pin to text side (see lg breakpoint below). */
.ride-manager-bullets-col {
  align-items: center;
}

.ride-manager-bullets-card {
  width: fit-content;
  max-width: 100%;
  margin-inline: auto;
  box-sizing: border-box;
  padding: 2.35rem 2rem;
  background: linear-gradient(
    155deg,
    rgba(255, 255, 255, 0.12) 0%,
    rgba(255, 255, 255, 0.04) 50%,
    rgba(0, 20, 50, 0.35) 100%
  );
  /* Runtime: stacked border + inset + large blur read as a wide white frame (see debug logs). */
  border: none;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  /* Single hairline ring + soft depth only (no inset highlight, no blue 40px blur) */
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.1),
    0 8px 22px rgba(0, 0, 0, 0.22);
}

@media (min-width: 992px) {
  .ride-manager-bullets-col {
    align-items: flex-start;
  }

  .ride-manager-bullets-card {
    padding: 3.15rem 2.9rem;
    margin-inline-end: auto;
    margin-inline-start: 0;
  }
}

.ride-manager-list {
  font-size: clamp(1.18rem, 1.65vw, 1.4rem);
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.ride-manager-li {
  padding: 0.5rem 0.35rem;
  margin: 0;
  border-radius: 14px;
  transition: background 0.2s ease;
}

.ride-manager-li:hover {
  background: rgba(255, 255, 255, 0.07);
}

.ride-manager-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.05rem;
  height: 2.05rem;
  margin-inline-end: 0.75rem;
  margin-top: 0.12rem;
  border-radius: 50%;
  font-size: 0.82rem;
  color: #fff;
  background: linear-gradient(145deg, #42dcc0, #089ec4);
  box-shadow:
    0 3px 10px rgba(52, 208, 182, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.35);
}

.ride-manager-check i {
  line-height: 1;
}

@media (min-width: 992px) {
  .ride-manager-hero-panel {
    min-height: 320px;
  }
}

@media (max-width: 575.98px) {
  .home-ride-manager-wrap {
    padding-top: 74px;
  }
  .ride-manager-title {
    font-size: clamp(2.65rem, 6vw, 3.35rem);
  }
  .ride-manager-kicker {
    font-size: clamp(0.88rem, 1.2vw, 1rem);
  }
}

@media (prefers-reduced-motion: reduce) {
  .ride-manager-hero-row,
  .ride-manager-hero-actions-row {
    animation: none;
  }
  .ride-manager-cta-shine {
    animation: none;
  }
  .ride-manager-cta:hover {
    transform: none;
  }
  .ride-manager-example-link:hover {
    transform: none;
  }
}

#welcome-section {
    padding-top: 24px;
    padding-bottom: 24px;
    height: 100dvh;
}

.text-welcome {
    font-size: 72px;
    font-weight: 800;
}

.input-icon {
    position: relative;
}

.input-icon input {
    padding-right: 6.4em;
    padding-left: 6.4em;
}

.fs-5 {
    font-size: 2rem !important;
}

.fa-plane_image{
  height: 31px;
}

.image-31px {
  height: 31px;
  width: 31px;
}

.py-3 {
    padding-bottom: 3rem !important;
    padding-top: 3rem !important;
}
.input-icon .fa-plane12 {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: linear-gradient(45deg, #34D0B6, #07A0C3);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.bg-welcome {
    position: relative;
    overflow: hidden;
    height: 100%;
}

.bg-welcome::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: var(--home-bg-image);
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    border-radius: 32px;
    transform: scaleX(1);
    transform-origin: center;
    z-index: 0;
}

.bg-welcome::after {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 32px;
    background: linear-gradient(45deg, rgba(43, 43, 43, 0), rgba(30, 30, 30, 0.8));
    z-index: 1;
}

.bg-welcome-mirrored::before {
    transform: scaleX(-1);
}
.rounded-4 {
  border-radius: 1.6rem !important;
}

.gap-3{
    gap: 1.6rem !important;
}
.p-4 {
    padding: 2.4rem !important;
}

.rounded-5{
	border-radius: 32px !important;
}

/* .gap-3{
  gap: 5rem !important;
} */

.gap-2{
  gap: .8rem !important;
}

@media (min-width: 768px){
  .gap-md-5{
    gap: 5rem !important;
  }
  .px-md-4 {
      padding-right: 2.4rem !important;
      padding-left: 2.4rem !important;
  }
    .py-md-5 {
        padding-top: 4.8rem !important;
        padding-bottom: 4.8rem !important;
    }

}

.margin-for-h2 {
    margin-bottom: 0.8rem !important;
}
.mb-md-2, .my-md-2 {
    margin-bottom: 2rem !important;
}
.position-index {
    position: relative;
    z-index: 2; /* Higher than the overlay */
}

.glass-card {
  background-color: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(8px);
}

.text-secondary {
    color: #0D2F29 !important;
}

.carousel-height {
    height: 450px;
}

.review-image {
    width: 100%;
    height: 100%;
}


.col-6 {
    flex: 0 0 40%;
    width: 40%;
}

@media (max-width: 575.98px) {
    .input-icon input {
        padding-right: 3.4em;
        padding-left: 0;
    }

    .text-welcome {
        font-size: 32px;
        font-weight: 800;
    }

    #welcome-section {
        padding-top: 16px;
        padding-bottom: 16px;
        height: 100dvh;
        min-height: 100dvh;
    }


    .full-width {
        width: 100% !important;
    }

    .carousel-height {
        height: 620px;
    }

    .review-image {
        width: 100%;
        height: 150px;
    }
    .col-6 {
      flex: 0 0 35%;
      width: 35%;
    }

}
.display_ruby{
    justify-content: center;
}

.fs-4 {
  font-size: 2.4rem !important;
}

.py-3 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
}
.px-3 {
    padding-right: 2.4rem !important;
    padding-left: 2.4rem !important;
}

.pading_top_and_butom_3{
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}
.fw-semibold {
    font-weight: 600 !important;
}
p {
    margin-top: 0;
    margin-bottom: 1.6rem;
}

img{
  height: revert-layer;
}
.fw-bold {
    font-weight: 700 !important;
}

@media (min-width: 1200px) {
    .h2, h2 {
        font-size: 3.6rem;
    }
}








body {
    font-family: "Nunito", sans-serif;
    font-optical-sizing: auto;
    color: #1e1e1e;
}

.text-primary {
    background-image: linear-gradient(45deg, #34D0B6, #07A0C3) !important;
    color: transparent !important;
    -webkit-background-clip: text !important;
    -moz-background-clip: text !important;
    background-clip: text !important;
}

.btn-primary {
    background: linear-gradient(45deg, #34D0B6, #07A0C3);
    color: white;
    border: 0;
}

.btn-primary:hover {
    background: linear-gradient(45deg, #39e1c5, #08add3);
    color: white;
    border: 0;
}

.btn-warning {
    background: linear-gradient(45deg, #E0BE36, #DD6E42);
    color: white;
    border: 0;
}

.btn-warning:hover {
    background: linear-gradient(45deg, #e8c538, #ee7748);
    color: white;
    border: 0;
}

.transparent-background-primary {
    background-color: rgba(7, 160, 195, 0.1) !important;
}

.font-64 {
    font-family: "Nunito Sans", sans-serif;
    font-optical-sizing: auto;
    font-size: 64px !important;
    font-weight: 800;
    color: #07A0C3;
    opacity: 20%;
    line-height: 64px !important;
}

#banner {
    height: 150px;
    /* background-image: url('/assets/images/banner-background.png'); */
    background-repeat: no-repeat;
    /*background-attachment: fixed;*/
    background-size: cover;
    color: white;
}


.vl {
    border-left: 2px solid rgba(7, 160, 195, 0.5);
    height: 100%;
}

.color-primary {
    color: #07A0C3 !important;
    border: 0
}

.text-orange {
    color: #DD6E42;
}

#review {
    background-color: rgba(7, 160, 195, 0.1);
    border-radius: 0 0 32px 32px;
}

#traveler-image {
    height: 100px;
    width: 100px;
    /* background-image: url("/assets/images/traveler-image.png"); */
    background-repeat: no-repeat;
    background-size: cover;
}

.fs-7 {
    font-size: 14px !important;
}

#map-mobile {
    height: 100% !important;
    width: 100% !important;
    /* background-image: url("/assets/images/map.svg"); */
    background-repeat: no-repeat;
    background-size: cover;
}

#scroll-map {
    position: sticky;
    top: 70px;
    height: 100vh;
    z-index: 1; /* Ensure the map stays above other content */
}

#location1 {
    height: 140px;
    width: 140px;
    /* background-image: url("/assets/images/location1.jpg"); */
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 20px;
}

#location2 {
    height: 140px;
    width: 140px;
    /* background-image: url("/assets/images/location2.jpg"); */
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 20px;
}

.border-primary {
    border-color: rgba(7, 160, 195, 0.3) !important;
}

.content {
    max-height: calc(1.5em * 2);
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    word-wrap: break-word;
    opacity: 60%;
}


.show-all-content {
    max-height: none; /* Show all content */
    -webkit-line-clamp: initial;
}

.stars {
    color: #FFD83B;
}

.waze {
    background-color: #05C8F7 !important;
    color: white;
}

.booking {
    background-color: #003580 !important;
    color: white;
}

.get-your-guide {
    background-color: #FF5532 !important;
    color: white;
}

.whats-up {
    background-color: #25D366 !important;
    color: white;
}

.whats-up:hover {
    background-color: #22c75f !important;
    color: white;
}


.bg-footer {
    background-color: #0D2F29;
}

.floating-buttons {
    position: fixed;
    bottom: 20px; /* Adjust the bottom margin as needed */
    right: 20px; /* Adjust the right margin as needed */
    display: flex;
    flex-direction: column-reverse;
    gap: 10px;
    z-index: 2 !important;
}

/* .carousel-control-prev-icon {
    background-image: url("../assets/images/arrows/carousel-control-prev-icon.svg");
}

.carousel-control-next-icon {
    background-image: url("../assets/images/arrows/carousel-control-next-icon.svg");
} */

.step-number-badge {
    height: 54px;
    width: 54px;
    top: 16px;
    right: 16px;
    color: #DD6E42;
    font-weight: 900;
    background-color: rgba(221, 110, 66, 0.25);
}

.bg-light-blue {
    background-color: #E6F5F9 !important;
}

.bg-light-orange {
    background-color: rgba(221, 110, 66, 0.15);
}

.background-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: -1;
}
.background-image-max-with-none {
  max-width: none;
}

.bg-card {
    background-size: cover !important;
    background-position: center center;
    background-repeat: no-repeat;
}

.image-how-it-works {
    height: 150px !important;
}

.accordion-button:focus {
    z-index: 3;
    outline: 0;
    box-shadow: 0 0 white;
}

.accordion {
    --bs-accordion-border-color: transparent;
}

@media (max-width: 575.98px) {
    .fs-7 {
        font-size: 14px !important;
    }

    .fs-6 {
        font-size: 15px !important;
    }

    .fs-5 {
        font-size: 16px !important;
    }

    .fs-4 {
        font-size: 18px !important;
    }

    #map {
        width: 100% !important;
    }

    #location1 {
        height: 90px;
        width: 90px;
        /* background-image: url("/assets/images/location1.jpg"); */
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 20px;
    }

    #location2 {
        height: 90px;
        width: 90px;
        /* background-image: url("/assets/images/location2.jpg"); */
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: 20px;
    }

    .get-your-guide-image {
        height: 16px !important;
    }

    .google-logo {
        height: 50px !important;
    }

    .waze-logo {
        height: 80px !important;
    }

    .skyscanner-logo {
        height: 30px !important;
    }

    .booking-logo {
        height: 30px !important;
    }

    .footer-image {
        height: 28px;
    }

    .step-number-badge {
        height: 42px;
        width: 42px;
    }

}
.black{
  color: #1e1e1e;
}
.what_can_be_done_explanation{
  color: rgba(33, 37, 41, 0.75) !important;
  font-size: 1.6rem !important;
  margin-bottom: 1.6rem;
}

.rounded-2 {
    border-radius: 0.5rem !important;
}

row.align-items-stretch {
    display: flex;
    flex-wrap: wrap;
}

.card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.bg-card {
    background-size: cover;
    background-position: center;
}

@media (min-width: 1200px) {
    .h4, h4 {
        font-size: 2.3rem;
    }
}
.h4, h4 {
    font-size: 2.2rem;
}
h2, h2 {
    font-size: calc(2.2rem + 1.5vw);
}
.justify-content-space-around {
    justify-content: space-around;
    padding-bottom: 15px;
}
.text-align-center {
    text-align: center;
}
.clickable:not(:disabled):not(.disabled) {
    cursor: pointer;
}

card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.card-body .flex-grow-1 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.card-body h4 {
    min-height: 50px; /* Adjust as needed */
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-body p {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem; /* Adjust as needed */
}
.internal-bady {
  line-height: 1.5;
  
}

</style>
